(function () {
  var reveal = function (root) {
    var items = (root || document).querySelectorAll('.sp-reveal:not(.sp-is-visible)');
    if (!items.length) return;
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('sp-is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var delay = parseInt(el.getAttribute('data-sp-delay') || '0', 10);
        window.setTimeout(function () { el.classList.add('sp-is-visible'); }, delay);
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach(function (el) { io.observe(el); });
  };

  var accordions = function (root) {
    (root || document).querySelectorAll('[data-sp-accordion]').forEach(function (group) {
      if (group.hasAttribute('data-sp-ready')) return;
      group.setAttribute('data-sp-ready', 'true');
      group.addEventListener('click', function (event) {
        var trigger = event.target.closest('[data-sp-accordion-trigger]');
        if (!trigger) return;
        var item = trigger.closest('[data-sp-accordion-item]');
        var open = item.classList.contains('sp-is-open');
        if (group.getAttribute('data-sp-accordion') === 'single') {
          group.querySelectorAll('[data-sp-accordion-item]').forEach(function (other) {
            other.classList.remove('sp-is-open');
            var btn = other.querySelector('[data-sp-accordion-trigger]');
            if (btn) btn.setAttribute('aria-expanded', 'false');
          });
        }
        if (!open) {
          item.classList.add('sp-is-open');
          trigger.setAttribute('aria-expanded', 'true');
        } else {
          item.classList.remove('sp-is-open');
          trigger.setAttribute('aria-expanded', 'false');
        }
      });
    });
  };

  var carousels = function (root) {
    (root || document).querySelectorAll('[data-sp-carousel]').forEach(function (carousel) {
      if (carousel.hasAttribute('data-sp-ready')) return;
      carousel.setAttribute('data-sp-ready', 'true');
      var track = carousel.querySelector('[data-sp-track]');
      if (!track) return;
      carousel.querySelectorAll('[data-sp-nav]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var dir = btn.getAttribute('data-sp-nav') === 'prev' ? -1 : 1;
          var first = track.firstElementChild;
          var step = first ? first.getBoundingClientRect().width + 24 : track.clientWidth * 0.8;
          track.scrollBy({ left: step * dir, behavior: 'smooth' });
        });
      });
    });
  };

  var tabs = function (root) {
    (root || document).querySelectorAll('[data-sp-tabs]').forEach(function (wrap) {
      if (wrap.hasAttribute('data-sp-ready')) return;
      wrap.setAttribute('data-sp-ready', 'true');
      wrap.addEventListener('click', function (event) {
        var tab = event.target.closest('[data-sp-tab]');
        if (!tab) return;
        var id = tab.getAttribute('data-sp-tab');
        wrap.querySelectorAll('[data-sp-tab]').forEach(function (el) {
          var active = el === tab;
          el.classList.toggle('sp-is-active', active);
          el.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        wrap.querySelectorAll('[data-sp-panel]').forEach(function (panel) {
          panel.classList.toggle('sp-is-active', panel.getAttribute('data-sp-panel') === id);
        });
      });
    });
  };

  var counters = function (root) {
    var nodes = (root || document).querySelectorAll('[data-sp-count]');
    if (!nodes.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        io.unobserve(el);
        var target = parseFloat(el.getAttribute('data-sp-count')) || 0;
        var dur = 1400;
        var start = null;
        var decimals = (el.getAttribute('data-sp-count').split('.')[1] || '').length;
        var step = function (ts) {
          if (!start) start = ts;
          var p = Math.min((ts - start) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = (target * eased).toFixed(decimals);
          if (p < 1) window.requestAnimationFrame(step);
        };
        window.requestAnimationFrame(step);
      });
    }, { threshold: 0.4 });
    nodes.forEach(function (el) { io.observe(el); });
  };

  var init = function (root) {
    reveal(root);
    accordions(root);
    carousels(root);
    tabs(root);
    counters(root);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  window.ShopiaSections = { init: init };
})();
